import Button from '../../../UI/Button/Button';
import './HeroBanner.css';
import Balancer from 'react-wrap-balancer';

import { Typography, Link, Box, Divider } from '@mui/material';

const HeroBanner = (props) => {
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != 'undefined') {
        window.location = url;
      }
    };
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
      send_to: 'AW-11121365082/jd1sCLjPwr0YENqgircp',
      event_callback: callback,
    });
    return false;
  }

  return (
    <Box
      sx={{
        mt: { xs: '4rem', md: '8rem' },
        mx: 'auto',
        textAlign: 'center',
        width: { xs: '90%', sm: '80%' },
      }}>
      <Typography
        variant='h2'
        component='h1'
        sx={{
          fontWeight: 'bold',
          fontSize: '3',
          maxWidth: '1400px',
          mx: 'auto',
        }}>
        <Balancer>Join the private network for founders in Singapore.</Balancer>
      </Typography>

      <Typography variant='h5' sx={{ my: '2rem', maxWidth: '1000px', mx: 'auto' }}>
        <Balancer>
          The 100 Club is a private mastermind community for friendly entrepreneurs based in Singapore.
        </Balancer>
      </Typography>
      <Link
        key={1}
        href='/payments'
        onClick={() => {
          gtag_report_conversion();
          window.lintrk('track', { conversion_id: 13351812 });
        }}
        sx={{
          textDecoration: 'none',
        }}>
        <Button text='Join Today' symbol='arrow' />
      </Link>
      <Divider variant='middle' sx={{ my: '6rem' }} />
    </Box>
  );
};

export default HeroBanner;
